import { uniqBy } from 'lodash';
import { DeviceStatusAirConnectAPIResponse } from '../deviceStatus.model';

function getGatewayErrors(
  data: DeviceStatusAirConnectAPIResponse[] | undefined
) {
  return (
    data &&
    uniqBy(
      data
        ?.filter((item) => item.nodeID === 31)
        .filter(
          (item) =>
            item.lastResponseState === 'GATEWAY_LOST' ||
            item.lastResponseState === 'ERROR' ||
            item.lastResponseState === 'GATEWAY_TIMEOUT'
        ),
      'deviceID'
    )
  );
}

export default getGatewayErrors;
